import trimEnd from "lodash-es/trimEnd";

const getURLForBasePage = () => {
  return "/";
};

const getURLForSwimmingPoolDetailsPage = (poolId: string) => {
  return trimEnd(`/swimming-pool-details/${poolId}`);
};

export const urlHelper = {
  getURLForBasePage,
  getURLForSwimmingPoolDetailsPage,
};
